"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Page;
const react_1 = __importDefault(require("react"));
const CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
const ThemeProvider_1 = __importDefault(require("@material-ui/styles/ThemeProvider"));
const core_1 = require("@material-ui/core");
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const clsx_1 = __importDefault(require("clsx"));
const theme_1 = __importDefault(require("../../styles/theme"));
const variables_1 = __importDefault(require("../../styles/variables"));
const useStyles = (0, core_1.makeStyles)((theme) => ({
    page: {
        margin: '0 auto',
        // padding: '1rem',
        fontFamily: variables_1.default.fonts.family.heading,
        fontSize: variables_1.default.fonts.size.regular,
        lineHeight: variables_1.default.fonts.lineHeight.regular,
        minHeight: '100vh',
        [theme.breakpoints.only('xs')]: {
            padding: '1rem 0',
        },
    },
}));
/**
 * A container component to build page for your application
 */
function Page({ className, theme = theme_1.default, children, }) {
    const classes = useStyles();
    return (react_1.default.createElement(ThemeProvider_1.default, { theme: theme },
        react_1.default.createElement(CssBaseline_1.default, null),
        react_1.default.createElement(Container_1.default, { className: (0, clsx_1.default)(classes.page, className), maxWidth: false }, children)));
}
